import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';

import { NavigationButton } from '../models/navigation-button.model';

@Component({
  selector: 'app-navigation-buttons',
  templateUrl: './navigation-buttons.component.html',
  styleUrls: ['./navigation-buttons.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
})
export class NavigationButtonsComponent {
  @Input() buttons: NavigationButton[] = [];
  @Input() currentHandyOrientation: string = '';
  @Output() navigate = new EventEmitter<string>();

  constructor(private router: Router) {}

  public onClickOnButton(button: NavigationButton): void {
    this.navigate.emit(button.link);
  }

  public isButtonActive(button: NavigationButton): boolean {
    const url = this.router.url;
    for (const r of button.activeOnRoutes) {
      if (url.startsWith(r)) return true;
    }
    return false;
  }
}
